import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { Ticket, TicketRecordType } from 'src/app/models/ticket/ticket.model';
import { getTicketType } from 'src/app/models/ticket/ticket.util';
import { LoadTickets, LoadTicketsFail, LoadTicketsSuccess } from '../../store';
import { SingleValueKPI } from '../types';
import { ChartType } from '../types/chart-type.types';
import { ChartService } from './chart.service';

@Injectable()
export class OpenCareCasesChartService extends ChartService<SingleValueKPI> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      const dataValue: number =
        data?.data?.filter((ticket) => this.filterByStatusAndType(ticket))
          .length || 0;

      return {
        ngClass: [],
        loading,
        data: {
          type: ChartType.SINGLE,
          id: 'Open care cases',
          title: 'All Open Care Tickets',
          value: dataValue,
          linkEnabled: true,
          linkParams: {
            groupBy: 'Type',
            view: 'open',
            type: TicketRecordType.Care,
          },
          hyperlink: '/tickets',
        } satisfies SingleValueKPI,
      };
    }),
  );

  private filterByStatusAndType(ticket: Ticket): boolean {
    return (
      getTicketType(ticket).includes(TicketRecordType.Care) && !ticket.IsClosed
    );
  }
}
